import { render, staticRenderFns } from "./startUpRule.vue?vue&type=template&id=70d1a478"
import script from "./startUpRule.vue?vue&type=script&lang=js"
export * from "./startUpRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports